import React from 'react'
import hero from '../images/illustration-hero.svg';
import music from '../images/icon-music.svg';

export default function Card() {
    return (
        <div className="max-w-sm bg-white  md:mx-auto my-24 mx-6 rounded-lg overflow-hidden">
      <img src={hero} alt="hero illustration" className="w-full object-cover"/>
      <div className="w-full text-center pt-10 px-4 md:px-14 font-redhat bg-white">
        <h1 className="text-darkblue font-extrabold text-lg tracking-wider">Order Summary</h1>
        <p className="text-desaturatedblue font-thin text-xs p-2">You can now listen to millions of songs,audiobooks,and podcasts on any device anywhere you like!</p>
      </div>
      <div className="flex justify-between items-center px-6 md:px-14 py-4 font-redhat">
        <span className="flex">
          <img src={music} className="max-w-sm" alt="pattern"/>
          <div className="px-4 py-2">
            <h2 className="text-sm font-bold text-darkblue tracking-wider">Annual Plan</h2>
            <p className="text-xs py-1 font-thin text-desaturatedblue tracking-wider">$59.99/year</p>
          </div>
        </span>
        <a href="#" className="text-brightblue text-sm font-bold font-redhat underline hover:no-underline">Change</a>
      </div>
      <div className="bg-brightblue text-white rounded-md mx-10 mt-8 shadow-2xl p-2 text-center hover:bg-desaturatedblue">
        <p className="font-semibold tracking-wider text-sm font-redhat">Proceed to Payment</p>
      </div>
      <div className="bg-transparent text-desaturatedblue rounded-md mx-10 my-8 p-2 text-center hover:text-darkblue">
        <p className="font-bold tracking-wider text-sm font-redhat">Cancel Order</p>
      </div>
    </div>
    )
}

/*<header>
               <p>Header</p>
           </header>
           <section>
               <h1>section 1 header</h1>
               <div className="split">
               <div>
                   <p>cnsknc</p>
               </div>
               <div>
                   <p>jnsdnnsk</p>
               </div>
               </div>
           </section>
           <section>
               <div className="split">
                   <div>
                       <h1>section 2 header</h1>
                       <p>kdsdjfjj</p>
                   </div>
                   <div>
                       <img src={image} alt="img"/>
                   </div>
               </div>
           </section>
           <section>
               <div className="split">
                   <div>
                       <img src={image} alt="img"/>
                   </div>
                   <div>
                       <h1>section 3 header</h1>
                       <p>kdsdjfjj</p>
                   </div>
               </div>
           </section>*/